module.exports = __webpack_public_path__ + "assets/img/fitfam-logo-white.c931ae70.png";